<template>
  <q-dialog v-model="downloadSchemesPage" class="share-grants-page">
    <q-card class="share-dialog">
      <q-card-section>
        <div class="text-h5 text-main bold-font">
          {{
            t("share_and_download_schemes.download_selected_items_as_a_report")
          }}
        </div>
      </q-card-section>
      <q-card-section>
        <div class="row justify-between top-section-responsive">
          <div class="column column-width">
            <span class="input-heading">
              {{ t("share_and_download_schemes.report_title") }} *
            </span>
            <q-input
              class="q-mt-sm input-share"
              borderless
              bg-color="white"
              v-model="reportTitle"
              dense
              :rules="requiredFieldRule"
            />

            <span class="input-heading q-mt-md">
              {{ t("share_and_download_schemes.description") }}
            </span>
            <q-input
              class="q-mt-sm input-share"
              borderless
              bg-color="white"
              v-model="description"
              type="textarea"
            />
          </div>
        </div>
      </q-card-section>

      <q-card-section class="report-type">
        <q-select
          square
          borderless
          bg-color="white"
          v-model="reportType"
          :options="reportOptions"
          :label="t('share_and_download_schemes.type_of_report')"
          style="width: 47%"
          option-label="description"
          option-value="id"
          emit-value
          map-options
        />
      </q-card-section>

      <q-card-actions class="q-mt-sm bold-font" align="left">
        <q-btn
          flat
          no-caps
          :label="t('search_schemes.download')"
          class="orange-btn-filled"
          @click="
            downloadSchemePageEmit(
              reportTitle,
              description,
              customerName,
              reportType
            )
          "
        />
        <q-btn
          no-caps
          flat
          :label="t('common.cancel')"
          class="orange-btn-cancel"
          v-close-popup
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { computed, ref } from "vue";
import store from "../../store/index";
import { useI18n } from "vue-i18n";
import grantsService from "../../services/grants.service";

export default {
  setup() {
    const { t } = useI18n();
    const downloadSchemesPage = computed({
      get: () => store.state.grantItems.downloadSchemesPage,
      set: (val) => store.commit("grantItems/disableDownloadSchemesPage", val),
    });

    const grant = computed({
      get: () => store.state.grantItems.grantToShare,
    });

    const downloadSchemePageEmit = async (
      reportTitle,
      description,
      customerName,
      reportType
    ) => {
      if (!reportTitle) return;

      const ids = store.state.grantItems.selectedResults
        .map((d) => d.schemeId)
        .join(",");

      const formData = new FormData();
      formData.append("reportType", reportType);
      formData.append("ids", ids);
      formData.append("reportTitle", reportTitle);
      formData.append("reportDescription", description);
      formData.append("customerName", customerName);

      // 2) post & download with XSRF header baked in
      try {
        await grantsService.postFormAndDownload(
          "/api/download/downloadSchemes",
          formData
        );
      } catch (err) {
        console.error("Download failed", err);
        // show user error UI…
      } finally {
        store.commit("grantItems/disableDownloadSchemesPage");
        store.commit("grantItems/updateisDisplayDownloadMessage");
      }
    };

    const address = ref("");
    const message = ref("");

    const reportTitle = ref("");
    const description = ref("");
    const customerName = ref("");
    const reportTemplate = ref("");
    const templateOptions = ["Template 1", "Template 2"];
    const searchCriteria = ref("");
    const sendWithinOrg = ref(false);

    const reportOptions = computed({
      get: () => store.state.mailing.reportTypesList,
    });
    const reportType = ref(0);

    return {
      t,
      reportOptions,
      reportType,
      sendWithinOrg,
      searchCriteria,
      templateOptions,
      reportTemplate,
      customerName,
      description,
      reportTitle,
      message,
      address,
      downloadSchemePageEmit,
      downloadSchemesPage,
      grant,
      requiredFieldRule: [
        (val) => (val && val.length > 0) || t("common.required_field"),
      ],
      isValidEmail(val) {
        const emailPattern =
          /^(?=[a-zA-Z0-9@._%+-]{6,254}$)[a-zA-Z0-9._%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,8}[a-zA-Z]{2,63}$/;
        return emailPattern.test(val) || t("common.invalid_email_address");
      },
    };
  },
};
</script>
